import { createReducer, Action, on } from '@ngrx/store';
import * as Actions from './user.actions';
import { initialState, State } from './user.state';
import { NotificationPreferences } from '@app/core/models/user.interface';

const userReducer = createReducer(
  initialState,
  on(Actions.getUserSuccess, (state, { user }) => ({
    ...state,
    user,
  })),
  on(Actions.getNotificationPreferencesSuccess, (state, { preferences }) => ({
    ...state,
    notificationPreferences: preferences,
  })),
  on(Actions.updateNotificationPreferenceSuccess, (state, { preference }) => ({
    ...state,
    notificationPreferences: {
      ...state.notificationPreferences,
      ...preference,
    } as NotificationPreferences,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return userReducer(state, action);
}
